import { atom } from "jotai";

export const isGiftCardModalOpenAtom = atom(false);
